import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import {
  LayoutDashboard, Users, ShoppingCart, Package,
  FileText, BarChart2, Settings, LogOut, Boxes
} from 'lucide-react';

const nav = [
  { label: 'SELL', items: [
    { icon: LayoutDashboard, name: 'Dashboard',    path: '/dashboard' },
    { icon: ShoppingCart,    name: 'Sales',        path: '/sales' },
    { icon: Users,           name: 'Contacts',     path: '/contacts' },
  ]},
  { label: 'PURCHASE', items: [
    { icon: Package,         name: 'Purchase',     path: '/purchase' },
  ]},
  { label: 'FINANCE', items: [
    { icon: FileText,        name: 'Journals',     path: '/journals' },
    { icon: FileText,        name: 'Chart of Accounts', path: '/coa' },
  ]},
  { label: 'STOCK', items: [
    { icon: Boxes,           name: 'Inventory',    path: '/inventory' },
    { icon: Package,         name: 'Products',     path: '/products' },
  ]},
  { label: 'REPORTS', items: [
    { icon: BarChart2,       name: 'Reports',      path: '/reports' },
  ]},
  { label: 'SYSTEM', items: [
    { icon: Settings,        name: 'Settings',     path: '/settings' },
  ]},
];

const Sidebar: React.FC = () => {
  const { logout, user } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  return (
    <div className="sidebar">
      <div className="nav-logo">KLIK OPS</div>
      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--bdr)' }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--tx)' }}>{user?.name}</div>
        <div style={{ fontSize: 11, color: 'var(--tx3)' }}>{user?.email}</div>
      </div>

      {nav.map(group => (
        <div key={group.label}>
          <span className="nav-label">{group.label}</span>
          {group.items.map(item => (
            <button
              key={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <item.icon size={14} />
              {item.name}
            </button>
          ))}
        </div>
      ))}

      <div style={{ position: 'absolute', bottom: 0, width: '100%', borderTop: '1px solid var(--bdr)', padding: 8 }}>
        <button className="nav-item" onClick={logout} style={{ color: 'var(--red)' }}>
          <LogOut size={14} />
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
